import {arrowsLoopSvg as Icon__small__arrowsLoopSvg} from '../Icon__small/Icon__small--arrowsLoop.js'
import {arrowsLoopSvg as Icon__xsmall__arrowsLoopSvg} from '../Icon__xsmall/Icon__xsmall--arrowsLoop.js'

export var arrowsLoop = {
  name: 'arrowsLoop',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowsLoopSvg,
  alt: {
    Icon__small: Icon__small__arrowsLoopSvg,
    Icon__xsmall: Icon__xsmall__arrowsLoopSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
